import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { UploadMaterialMetadataModel } from '../../models/document-metadata.model';
import { JscHearingRequestDocumentModel } from '../../models/jsc-hearing-request-document.model';
import { PartySummaryModel } from '../../models/party-summary.model';
import { SpecialRequirementSelectionModel } from '../../models/special-requirment-selection.model';
@Component({
  selector: 'jsg-jsc-hearing-details-view',
  templateUrl: './jsc-hearing-details-view.component.html',
  styleUrls: ['./jsc-hearing-details-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JscHearingDetailsViewComponent implements OnInit {
  @Input() remedySought: string;
  @Input() hearingDate: Date;
  @Input() hearingTime: string;
  @Input() variedDeadlines: boolean;
  @Input() comments: string;
  @Input() specialRequirementNotes: string;
  @Input() specialRequirementsSelection: SpecialRequirementSelectionModel[];

  @Input() displayedColumns: string[];
  @Input() hearingRequestDocuments: JscHearingRequestDocumentModel[];

  @Output() openFile = new EventEmitter<UploadMaterialMetadataModel>();

  constructor() {}

  ngOnInit(): void {}

  public onOpenFile = (args: UploadMaterialMetadataModel) => {
    this.openFile.emit(args);
  };
}
